import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "sales",
    type: "boolean",
    sortable: true,
    searchable: true,
  },
  {
    name: "purchases",
    type: "boolean",
    sortable: true,
    searchable: true,
  },
  {
    name: "image",
    type: "image",
    sortable: true,
    searchable: true,
  },
];

export default function List() {
  return <ResourceListPage url="categories" columns={columns} />;
}
